import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  MatButtonModule, MatToolbarModule, MatSidenavModule, MatListModule, MatIconModule
  , MatGridListModule, MatCardModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule
  , MatButtonToggleModule, MatChipsModule, MatTabsModule, MatExpansionModule, MatSnackBarModule, MatCheckboxModule
  , MatRippleModule, MatBadgeModule, MatProgressSpinnerModule, MatProgressBarModule, MatBottomSheetModule, MatSliderModule, MatRadioModule
} from "@angular/material";

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatTabsModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatRippleModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatBottomSheetModule,
    MatSliderModule,
    MatRadioModule
  ],
  exports: [
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatGridListModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatTabsModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatRippleModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatBottomSheetModule,
    MatSliderModule,
    MatRadioModule
  ]
})
export class AppMaterialModule { }
